<div fxLayoutAlign="center center">
  <button mat-raised-button color="primary"
          [routerLink]="['/playgrounds', view.id, 'edit']" class="btn-edit-playground">
    {{'GENERAL.EDIT' | translate}}
  </button>

</div>
